import React from 'react'

const playerTimer = ({
    position,
    duration,
}) => {
    const msToTime = time => {
        if (!time) return null;

        let seconds = parseInt((time / 1000) % 60, 10);
        const minutes = parseInt((time / (1000 * 60)) % 60, 10);

        seconds = seconds < 10 ? `0${seconds}` : seconds;

        return `${minutes}:${seconds}`;
    }

    return (
        <div className="player-timer">
            <span className="time-current">{msToTime(position) || '00:00'}</span>
            <span className="time-end">{msToTime(duration) || '00:00'}</span>
        </div>
    )
}

export default playerTimer
